import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import UnstyledHeading from '@components/shared/unstyled-heading';

import './not-authenticated.scss';

const NotAuthenticatedLayout = ({ children }) => {
  const config = useSelector(state => state.config);

  const loginBackground = useMemo(() => ({
    backgroundImage: `url(${
      (config.siteLoaded && config.backgroundPath) ||
      'https://storage.googleapis.com/coordinate-assets/background/default.png'
    })`
  }), [config.siteLoaded, config.backgroundPath]);

  if (!config.siteLoaded) {
    return null;
  }

  return (
    <main styleName="not-authenticated-wrap" style={loginBackground}>
      <div styleName="ie-spacer"/>
      <div styleName="not-authenticated-body">
        <UnstyledHeading rank={1} styleName="not-authenticated-heading">
          <span styleName="not-authenticated-heading-logo">
            <img src={`${config.LOGIN_ICON_URL}/coordinate-logo-white-horizontal.svg`} alt="coordinate" />
          </span>
          <span styleName="not-authenticated-heading-divider" />
          <span styleName="not-authenticated-heading-text">{config.cityName}</span>
        </UnstyledHeading>
        <div>
          {children}
        </div>
      </div>
      <div styleName="ie-spacer"/>
    </main>
  );
};

NotAuthenticatedLayout.propTypes = {
  children: PropTypes.element
};

export default NotAuthenticatedLayout;
